/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refund_Mode_NoneInputs */

const vi_refund_mode_none = /** @type {(inputs: Refund_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không hoàn`)
};

/**

* @param {Refund_Mode_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const refund_mode_none = /** @type {((inputs?: Refund_Mode_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refund_Mode_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_refund_mode_none(inputs)
});